import { ORDER_TYPE_ATONCE } from '../shop/constants';

export const getAvailabilityDisplay = n => (n > 500 ? '500+' : String(n));

/**
 * @name getTotalAvailability
 * @desc sum availability quantities of 'general' and 'contract' for a given product size
 * @param {object} sizeAvailability object containing size availability data
 */
export const getTotalAvailability = sizeAvailability =>
  sizeAvailability ? Object.values(sizeAvailability).reduce((acc, qty) => acc + (qty || 0), 0) : 0;

export const establishQuantities = sizeMatch => {
  const availability = { GENERAL: 0, CONTRACT: 0 };

  return sizeMatch
    ? Object.keys(sizeMatch).reduce((acc, type) => {
        acc[type] += sizeMatch[type];

        return acc;
      }, availability)
    : availability;
};

export const mapAvailability = (productAvailability, departmentType, selectedProduct, sizeConversion) => {
  if (!selectedProduct.sizes) return [];

  const { productCode, sizes, expired } = selectedProduct;
  const currAvailability = Object.keys(productAvailability).length > 0 && productAvailability[productCode];

  let currSizeData;

  if (expired || departmentType === ORDER_TYPE_ATONCE) {
    currSizeData = sizes.map(currSize => {
      const { sizeCode } = currSize;
      const sizeMatch = currAvailability && currAvailability[sizeCode];

      return {
        availability: establishQuantities(sizeMatch),
        code: productCode,
        sizeCode: currSize.sizeCode,
        displaySize:
          sizeConversion && currSize.sizeConversions
            ? currSize.sizeConversions.find(sc => sc.sizeTypeCode === sizeConversion)?.sizeDisplay
            : currSize.displaySize,
        sizeConversions: currSize.sizeConversions,
        promoIndicator: currSize.promoIndicator,
        sortOrderNumber: currSize.sortOrderNumber
      };
    });
  } else {
    currSizeData = sizes.map(currSize => ({
      ...currSize,
      code: productCode,
      displaySize: currSize.sizeDisplay || currSize.displaySize
    }));
  }

  return currSizeData;
};

export const mapFutureAvailability = (futureAvailability, productCode, sizes) => {
  if (!sizes) return [];

  const allDates = [];
  Object.values(futureAvailability).forEach(size => allDates.push(...Object.keys(size)));
  const allUniqueDates = [...new Set(allDates)].sort();

  const futureSizeData = sizes.map(size => {
    const { sizeCode } = size;
    const sizeMatch = futureAvailability && futureAvailability[sizeCode];

    const availByDate = {};
    if (sizeMatch) {
      allUniqueDates.forEach(date => {
        availByDate[date] = establishQuantities(sizeMatch[date] || null);
      });
    }

    // update sizeCode here too
    return {
      availability: availByDate,
      productCode,
      sizeCode
    };
  });

  return { futureSizeData, allUniqueDates };
};
